import { CampaignHealthOption, IncludeExclude } from "../../../utils/types";
import Autocomplete from "../../library/Autocomplete";
import CAMPAIGN_HEALTH_OPTIONS from "./campaignHealthOptions";

interface CampaignHealthAutocompleteProps {
  onChange: (selected: CampaignHealthOption[]) => void;
  selected: CampaignHealthOption[];
  reactRef?: any;
  disabled?: boolean;
  multiple?: boolean;
  style?: {[key:string]:string};
  useIncludeExclude?: boolean;
  defaultIncludeExclude?: IncludeExclude;
  includeExcludeOnChange?: (newIncludeExclude:IncludeExclude) => void;
  options?: CampaignHealthOption[]; // Allow custom options, fallback to default
}

function CampaignHealthAutocomplete(props: CampaignHealthAutocompleteProps) {
  const labelKeyFunction = (option: CampaignHealthOption) => {
    return option.name;
  }

  const handleChange = (selected: CampaignHealthOption[]) => {
    props.onChange(selected);
  }

  return (
    <Autocomplete
      id="campaignHealthAutocomplete"
      placeholder="Campaign Health"
      reactKey="campaignHealthAutocomplete"
      labelKey={labelKeyFunction}
      onChange={handleChange}
      options={props.options || CAMPAIGN_HEALTH_OPTIONS}
      selected={props.selected}
      reactRef={props.reactRef}
      disabled={props.disabled}
      useIncludeExclude={props.useIncludeExclude}
      defaultIncludeExclude={props.defaultIncludeExclude}
      includeExcludeOnChange={props.includeExcludeOnChange}
      multiple={props.multiple}
      style={props.style}
      paginate={false}
      maxResults={CAMPAIGN_HEALTH_OPTIONS.length + 1}
      keepDropdownOpen={true}
    />
  );
}

export default CampaignHealthAutocomplete;